import { render } from "./three-detailed-pitch.vue?vue&type=template&id=1309b0c8&scoped=true&ts=true"
import script from "./three-detailed-pitch.vue?vue&type=script&lang=ts"
export * from "./three-detailed-pitch.vue?vue&type=script&lang=ts"

import "./three-detailed-pitch.vue?vue&type=style&index=0&id=1309b0c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1309b0c8"]])

export default __exports__